import React from "react";
import styled from "styled-components";
import { Colors } from "../../ColorConstants";
import { Text } from "../../TextConstants";
import { Parks } from "../../assets/images";
import { PlayStore, AppStore } from "../../assets/images";

const DownloadApp = () => {
  return (
    <BookingAppContainer>
      <DownloadTexts>
        <DownloadTitleText>{Text.downloadApp}</DownloadTitleText>
        <DownloadSubText>{Text.DownloadDetail}</DownloadSubText>
        <StoreImages>
          <a href="https://play.google.com/store/apps/details?id=com.estithmarholding.almahaisland&hl=en_ZA&gl=US">
            <StoreImage src={PlayStore} alt="Play Store" />
          </a>
          <a href="https://apps.apple.com/app/apple-store/id6443964600?pt=118552829&ct=Al%20Maha%20App%20Download&mt=8">
            <StoreImage src={AppStore} alt="App Store" />
          </a>
        </StoreImages>
      </DownloadTexts>
      <ImageContainer>
        <Image src={Parks} alt="Parks" />
      </ImageContainer>
    </BookingAppContainer>
  );
};

const BookingAppContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 1rem;
`;
const DownloadTexts = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 1rem;
`;

const DownloadTitleText = styled.span`
  color: ${Colors.black};
  text-align: center;
  font-size: 1.5rem;
  font-weight: 600;
  @media (max-width: 700px) {
    font-size: 0.938rem;
  }
`;
const DownloadSubText = styled.span`
  color: ${Colors.lightGrey};
  text-align: center;
  padding: 1rem 18rem;
  font-weight: 400;
  font-size: 1rem;
  @media (max-width: 768px) {
    padding: 1rem 2rem;
  }
`;

const StoreImages = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 1rem;
  @media (min-width: 700px) {
    flex-direction: row;
  }
`;

const StoreImage = styled.img`
  width: 200px;
  margin-left: 1rem;
  @media (max-width: 768px) {
    margin-left: 0rem;
  }
`;

const ImageContainer = styled.div`
  margin-top: 1.2rem;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Image = styled.img`
  width: 60%;
  @media (max-width: 700px) {
    width: 90%;
  }
`;

export default DownloadApp;
